import React from 'react'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import Colors from '../../../assets/styles/Colors'
import { Scrollbar } from '../../../assets/styles/GlobalStyle'
import Button from '../buttons/Button'
import PdfViewer from '../PdfViewer'
import CustomLink from '../CustomLink'
import { t } from 'i18next'
//
//
const DialogModal: React.FC<{
  title?: string
  isOpen: boolean
  onClose: Function
  src?: string
  isPdf?: boolean
  acceptOnClick?: () => void
  declineOnClick?: () => void
}> = ({ title = 'title', isOpen = false, onClose, src, isPdf = false, acceptOnClick, declineOnClick }) => {
  //
  //
  return isOpen === false ? null : (
    <Wrapper className="dialog-modal-without-live-chat-widget">
      <Scrollbar hideScroll={isOpen} />
      <ShadowBackground onClick={() => onClose()} />
      <Content>
        <HeadSide>
          <h6>{title}</h6>
          <CloseModalBtn onClick={() => onClose()}>
            <CloseIcon />
          </CloseModalBtn>
        </HeadSide>
        {/*  */}

        <ChildrenBlock>
          <ModalTitle>{title}</ModalTitle>

          {isPdf ? (
            <IframeContent>
              <PdfView>
                <PdfViewer url={src} />
              </PdfView>
            </IframeContent>
          ) : (
            <iframe
              id="iframe"
              loading="eager"
              src={`${src}#toolbar=0&view=fitH&navpanes=0`}
              title={'url'}
              style={{ width: '100%', height: '100%', boxSizing: 'border-box', border: '0px', objectFit: 'cover' }}
            ></iframe>
          )}
        </ChildrenBlock>

        <ButtonSBlock>
          <Button buttonType="primary" text={t('consent')} onClick={acceptOnClick} />
          <CustomLink onClick={declineOnClick} text={t('refusal')} />
        </ButtonSBlock>
      </Content>
    </Wrapper>
  )
}
//
//
const PdfView = styled.div`
  height: 376px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  ${Responsive.mobile} {
    height: 100%;
  }
`
const IframeContent = styled.div`
  /*  */
  ${Responsive.mobile} {
    overflow: auto;
  }
`
const ModalTitle = styled.h3`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 24px;

  ${Responsive.mobile} {
    display: none;
  }
`
const ButtonSBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 40px;

  a {
    margin-left: 40px;
  }

  ${Responsive.mobile} {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 24px;

    a {
      margin-left: 0px;
    }

    button {
      width: 100%;
      &:first-child {
        margin-right: 0px;
        margin-bottom: 20px;
      }
    }
  }
`
const HeadSide = styled.div`
  /*  */
  h6 {
    width: 85%;
    margin-bottom: 0px;
    padding-left: 20px;
    font-size: 14px;
    color: ${Colors.primaryBlack};
    display: none;
  }
  /*  */
  ${Responsive.mobile} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: 0 0 20px 0 rgba(151, 153, 193, 0.18);

    h6 {
      display: block;
    }
  }
`
const ChildrenBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 90px);

  ${Responsive.mobile} {
    padding-top: 34px;
    height: calc(100% - 210px);
  }
`
const CloseModalBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: 0px;
  background-color: transparent;
  outline: none;
  padding: 10px;
  position: absolute;
  top: 14px;
  right: 14px;
  svg {
    width: 14px;
    height: 14px;
    color: ${Colors.rollingStone};
  }
  /*  */
  &:hover {
    svg {
      color: ${Colors.primaryBlack};
    }
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 101;

  /*  */
  ${Responsive.mobile} {
    /* z-index: 3; */
  }
`
const ShadowBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: black;
  opacity: 0.3;
  width: 100%;
  height: 100vh;
`
const Content = styled.div`
  padding: 56px;
  background-color: ${Colors.white};
  z-index: 6;
  border-radius: 8px;
  position: relative;
  max-width: 720px;
  height: 630px;
  width: 100%;

  /*  */
  ${Responsive.mobile} {
    padding: 64px 20px 20px 20px;
    max-width: unset;
    width: 100%;
    height: 100vh;
    border-radius: 0px;
  }
`
//
//
export default DialogModal
